type FilmpleAnalyticsEventName =
  | 'register'
  | 'purchase_any'
  | 'purchase_social'
  | 'purchase_pro';

type FilmpleAnalyticsParams = Record<string, string | number | boolean | null | undefined>;

declare global {
  interface Window {
    dataLayer?: Array<Record<string, string | number | boolean>>;
  }
}

function pushAnalyticsEvent(event: FilmpleAnalyticsEventName, params: FilmpleAnalyticsParams = {}): void {
  if (typeof window === 'undefined') return;

  const payload: Record<string, string | number | boolean> = { event };
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) {
      payload[key] = value;
    }
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}

export function trackRegisterCompleted(): void {
  pushAnalyticsEvent('register');
}

export function trackPurchaseCompleted(
  tier: 'social' | 'pro',
  params: FilmpleAnalyticsParams = {},
): void {
  const purchaseParams = { ...params, plan_tier: tier };
  pushAnalyticsEvent('purchase_any', purchaseParams);
  pushAnalyticsEvent(tier === 'social' ? 'purchase_social' : 'purchase_pro', purchaseParams);
}
